import { render, staticRenderFns } from "./AccountAllocation.vue?vue&type=template&id=b6b128e6&scoped=true"
import script from "./AccountAllocation.vue?vue&type=script&lang=js"
export * from "./AccountAllocation.vue?vue&type=script&lang=js"
import style0 from "./AccountAllocation.vue?vue&type=style&index=0&id=b6b128e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b128e6",
  null
  
)

export default component.exports